import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PostcodeGroup } from './meta-data.service';

@Injectable({
  providedIn: 'root'
})
export class PostcodeManagerService {
  public SelectedPostcodeGroup: PostcodeGroup = null;
  public PostcodeGroups: Array<PostcodeGroup> = [];

  constructor() { }
}
